import { useState, useEffect } from "react";

const links = [
  { label: "Services", href: "#services" },
  { label: "Features", href: "#features" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-background-50"
      }`}
    >
      <nav className="flex items-center justify-between h-16 px-4 md:px-6 max-w-7xl mx-auto">
        <a href="#top" className="flex items-center gap-2 cursor-pointer shrink-0">
          <img
            src="https://up.abstractdata.ai/uploads/2025/08/AbstractDataLogo-2.png"
            alt="Abstract Data"
            className="h-8 w-auto"
          />
          <span className="font-heading font-bold text-lg text-foreground-950 whitespace-nowrap">
            Abstract Data
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="px-4 py-2 text-sm whitespace-nowrap rounded-md cursor-pointer text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-2">
          <a
            href="#contact"
            className="px-5 py-2 text-sm font-medium whitespace-nowrap rounded-md bg-foreground-950 text-background-50 hover:bg-foreground-800 cursor-pointer transition-colors"
          >
            Get in touch
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer text-foreground-950"
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`} />
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 pb-4 pt-2 flex flex-col gap-1">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="px-4 py-3 text-sm text-foreground-800 hover:bg-background-100 rounded-md cursor-pointer"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setOpen(false)}
            className="mt-2 px-4 py-3 text-sm font-medium text-center rounded-md bg-foreground-950 text-background-50 hover:bg-foreground-800 cursor-pointer"
          >
            Get in touch
          </a>
        </div>
      )}
    </header>
  );
}